module.exports = __webpack_public_path__ + "static/media/picture-(184).4aac138d.JPG";